import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class ReturnRegister {
  // 获取列表
  static getList(options) {
    let url = `/zwy/api/refund/register/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  static postDelList(id) {
    const url = `/zwy/api/refund/register/del?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 登记
  static postRegister(data) {
    const url = `/zwy/api/refund/register/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导出
  static getExportExcel(options) {
    let url = `/zwy/api/download/refund/register?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default ReturnRegister